import { useFormik } from "formik";
import ModalComponent from "..";
import { useDuplicateEventMutation } from "../../../redux/features/event/event.api";
import { CreatedEvent } from "../../../redux/features/event/event.types";
import { ModalCompProps } from "../../../utils/types";
import { DuplicateEventSchema } from "../../../utils/validations";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";
import { TextInput } from "../../inputs/textInput";
import { MiniHeader } from "../../typography/miniHeader";

export const DuplicateEventModal = ({
  open,
  handleClose,
  event,
  onSuccess,
}: ModalCompProps & {
  event: CreatedEvent;
  onSuccess: () => void;
}) => {
  const [duplicateEvent, { isLoading }] = useDuplicateEventMutation();

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    resetForm,
  } = useFormik({
    initialValues: {
      name: "",
    },

    validationSchema: DuplicateEventSchema,
    onSubmit: async (vals) => {
      const resp = await duplicateEvent({
        id: event._id,
        name: vals.name,
      });

      if (resp?.data?.status === "success") {
        onSuccess();
        resetForm();
      }
    },
  });

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
        resetForm();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Icon
          svg={"copy-plus"}
          width={42}
          height={42}
          className="rounded-xl border border-grey-100 p-[11px]"
        />

        <div>
          <MiniHeader
            header={`Duplicate “${event.name}”`}
            subheader="Create a new event with the same information as this one. Everything except the guest list will be duplicated. Once duplicated, it would be saved as a draft and you can publish it anytime."
          />
        </div>

        <TextInput
          type="text"
          value={values.name}
          hasTitle
          title="New Event Name"
          placeholder=""
          onBlur={handleBlur}
          onChange={handleChange}
          name="name"
          readOnly={false}
          errors={touched.name && errors.name ? errors.name : undefined}
        />

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
              resetForm();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Duplicate Event"}
            type="submit"
            onClick={() => {}}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"primary"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
